import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import './account.less';
import {
  fetchLenderAccount,
  fetchLoans,
  filterDisplayedLoans
} from './accountActions';
import { getError, isBusy, withActions } from 'actionware';
import Button from '../../components/button/button';
import Panel from '../../components/panel/panel';
import * as numeral from 'numeral';
import { dateFormat, moneyFormat } from '../../common/constants';
import Section from '../../components/section/section';
import * as classnames from 'classnames';
import moment from 'moment';

@connect(
  ({
    localize,
    account: { activeLoans, repaidLoans, displayingActiveLoans }
  }) => ({
    translate: getTranslate(localize),
    loading: isBusy(fetchLoans) || isBusy(fetchLenderAccount),
    error: getError(fetchLoans),
    activeLoans,
    repaidLoans,
    displayingActiveLoans
  })
)
@withActions({
  filterDisplayedLoans
})
export default class LoansMobile extends PureComponent {
  filterActiveLoans = () => {
    this.props.filterDisplayedLoans(true);
  };

  filterPaidLoans = () => {
    this.props.filterDisplayedLoans(false);
  };

  loanPanel(loan) {
    const { translate } = this.props;
    const {
      id,
      status,
      investmentAmount,
      amount,
      interestRate,
      tenor,
      nextRepaymentDate
    } = loan;

    const statusText =
      status === 'disbursed'
        ? translate('loan.statusActive')
        : translate('loan.fullyRepaid');

    return (
      <Panel key={id} className={'loan-item'}>
        <div className={'loan-item-income'}>
          <div className={'label'}>{translate('loan.incomeReceived')}</div>
          <h1>
            {translate('generic.amount', {
              value: numeral(amount).format(moneyFormat)
            })}
          </h1>
        </div>
        <div className={'loan-item-details split-list'}>
          <dl>
            <dt>{translate('loan.nextRepaymentDate')}</dt>
            <dd>
              {nextRepaymentDate
                ? moment(nextRepaymentDate).format(dateFormat)
                : '---'}
            </dd>
            <dt>
              {translate('loan.interest') + ' / ' + translate('loan.tenor')}
            </dt>
            <dd>{`${interestRate} / ${tenor}`}</dd>
          </dl>
          <dl>
            <dt>{translate('loan.investmentAmount')}</dt>
            <dd>
              {translate('generic.amount', {
                value: numeral(investmentAmount).format(moneyFormat)
              })}
            </dd>
            <dt>{translate('loan.status')}</dt>
            <dd
              className={classnames('status', {
                active: status === 'disbursed'
              })}
            >
              {statusText}
            </dd>
          </dl>
        </div>
      </Panel>
    );
  }

  render() {
    const {
      translate,
      loading,
      displayingActiveLoans,
      activeLoans,
      repaidLoans
    } = this.props;
    const loans = displayingActiveLoans ? activeLoans : repaidLoans;
    return (
      <Section
        className={'account-loans-mobile'}
        title={translate('loan.loanList')}
        subtitle={
          activeLoans.length || repaidLoans.length
            ? translate('loan.currentLoans', {
                activeLoans: activeLoans.length,
                repaidLoans: repaidLoans.length
              })
            : null
        }
      >
        <div className={'content'}>
          <div className={'loans-filter-buttons inline-buttons'}>
            <Button
              disabled={loading}
              onClick={this.filterActiveLoans}
              active={displayingActiveLoans}
            >
              {translate('loan.active')}
            </Button>
            <Button
              disabled={loading}
              onClick={this.filterPaidLoans}
              active={!displayingActiveLoans}
            >
              {translate('loan.fullyPaid')}
            </Button>
          </div>
          {loans.map(loan => this.loanPanel(loan))}
        </div>
      </Section>
    );
  }
}
